module.exports = __webpack_public_path__ + "img/gb1340.prt.4beaeb7f.jpg";